import { Header, Table } from '@tanstack/react-table';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DataTableHeaderCell } from './DataTableHeaderCell';

interface DataTableSortableHeaderCellProps<T> {
  header: Header<T, unknown>;
  table: Table<T>;
  hideRounding?: boolean;
  withFilters?: boolean;
  withFixedColumnWidth?: boolean;
  withColumnGroups?: boolean;
  isLastInRow?: boolean;
  onSortClick: React.MouseEventHandler<HTMLTableCellElement>;
}

export const DataTableSortableHeaderCell = <T,>(
  props: DataTableSortableHeaderCellProps<T>
) => {
  const {
    setNodeRef,
    transform,
    transition,
    attributes,
    listeners,
    isDragging,
  } = useSortable({ id: props.header.column.id });

  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(
      transform ? { ...transform, y: 0 } : null
    ),
    transition,
    cursor: isDragging ? 'grabbing' : 'grab',
  };

  return (
    <DataTableHeaderCell
      {...props}
      ReorderProps={{
        ref: setNodeRef,
        style,
        attributes,
        listeners,
        active: isDragging,
      }}
    />
  );
};
